var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30.000000pt",
    height: "30.000000pt",
    viewBox: "0 0 30.000000 30.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,30.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78 279 c-43 -22 -78 -81 -78 -129 0 -76 74 -150 150 -150 76 0 150 74 150 150 0 50 -35 107 -80 130 -49 25 -94 25 -142 -1z m150 -61 c16 -16 16 -120 0 -136 -16 -16 -140 -16 -156 0 -16 16 -16 120 0 136 16 16 140 16 156 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 213 c-8 -3 -13 -24 -13 -53 0 -76 4 -80 70 -80 84 0 90 4 90 60 0 76 -4 80 -74 79 -33 0 -67 -3 -73 -6z m101 -29 c31 -30 9 -84 -34 -84 -26 0 -50 27 -50 55 0 40 54 59 84 29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 174 c-9 -8 -16 -19 -16 -24 0 -11 29 -40 40 -40 11 0 40 29 40 40 0 11 -29 40 -40 40 -5 0 -16 -7 -24 -16z m24 -8 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraActive);
export default __webpack_public_path__ + "static/media/camera_active.b96abce92f3a1bbfada37bd7054178b3.svg";
export { ForwardRef as ReactComponent };